export interface ProductPomMeasurementItem {
    epimPomId: number;
    descriptionTr: string;
    pomSizeValue: number | null;
}

export interface ProductPomMeasurementSizeGroup {
    sizeCode: string;
    barcode: number;
    measurements: ProductPomMeasurementItem[];
}

export interface ProductAttributeItem {
    key: string;
    value: string;
}

export interface ProductPomMeasurementResponse {
    requestedBarcode: number;
    modelCode: string;
    colorCode: string;
    epimOptionId: number | null;
    sizes: ProductPomMeasurementSizeGroup[];
    productAttributes?: ProductAttributeItem[];
}

const dedupeMeasurements = (
    measurements: ProductPomMeasurementItem[] = []
): ProductPomMeasurementItem[] => {
    const seen = new Map<number, ProductPomMeasurementItem>();
    for (const measurement of measurements) {
        if (!seen.has(measurement.epimPomId)) {
            seen.set(measurement.epimPomId, measurement);
        }
    }
    return Array.from(seen.values());
};

export const formatSizeMeasurementsText = (measurements: ProductPomMeasurementItem[] = []): string =>
    dedupeMeasurements(measurements)
        .map((m) => `"${m.descriptionTr}":${m.pomSizeValue ?? ''}`)
        .join(',');

export const formatProductAttributesText = (attributes: ProductAttributeItem[] = []): string =>
    attributes.map((a) => `"${a.key}":${a.value}`).join(',');

export const formatBedenBilgileriText = (
    measurements: ProductPomMeasurementItem[] = [],
    attributes: ProductAttributeItem[] = []
): string =>
    [formatSizeMeasurementsText(measurements), formatProductAttributesText(attributes)]
        .filter(Boolean)
        .join('\n');
